export function checkStagesAssetsTransitionsAndUsers (
  tempConfigFile,
  rolID,
  users
) {
  return new Promise((resolve, reject) => {
    const stagesAffected = [];
    const subStagesAffected = [];
    const assetsAffected = [];
    const assetsAttrAffected = [];
    const transitionsAffected = [];
    const usersAffected = [];

    const rolName =
      tempConfigFile.roles[
        tempConfigFile.roles.findIndex(role => role.id === rolID)
      ].name;

    tempConfigFile.stages.forEach(stage => {
      stage.stages.forEach(subStage => {
        if (subStage.roles.length === 1 && subStage.roles[0] === rolName) {
          if (stagesAffected.findIndex(item => item.id === stage.id) === -1) {
            stagesAffected.push(stage);
          }
          subStagesAffected.push({
            stage,
            subStage
          });
        }
      });
    });

    tempConfigFile.assetTypes.forEach(asset => {
      asset.attributes.forEach(attr => {
        if (
          attr.visualizationRoles.length === 1 &&
          attr.visualizationRoles[0] === rolName
        ) {
          if (assetsAffected.findIndex(item => item.id === asset.id) === -1) {
            assetsAffected.push(asset);
          }
          assetsAttrAffected.push({
            asset,
            attr
          });
        }
      });
    });

    tempConfigFile.transitions.forEach(transition => {
      if (transition.roles.length === 1 && transition.roles[0] === rolName) {
        transitionsAffected.push(transition);
      }
    });

    for (var user in users) {
      if (
        users[user].Attributes[
          users[user].Attributes.findIndex(attr => attr.Name === 'role')
        ].Value === rolName
      ) {
        usersAffected.push(users[user]);
      }
    }

    resolve({
      rolID,
      stagesAffected,
      subStagesAffected,
      assetsAffected,
      assetsAttrAffected,
      transitionsAffected,
      usersAffected
    });
  });
}

export function deleteRoleProcess (tempConfigFile, affectedDependencies) {
  return new Promise((resolve, reject) => {
    const rolName =
      tempConfigFile.roles[
        tempConfigFile.roles.findIndex(
          role => role.id === affectedDependencies.rolID
        )
      ].name;

    const newTempConfigFile = {
      ...tempConfigFile,
      permissions: tempConfigFile.permissions.filter(
        perm => perm.role !== rolName
      ),
      roles: tempConfigFile.roles.filter(role => role.name !== rolName)
    };

    resolve({ ...newTempConfigFile });
  });
}
